<app-top-traffic-pie [origin]="origin"></app-top-traffic-pie>